// export const DOMAIN = "https://telelawmh.in/apiv2collectorapp/public/api/";
// export const USERLOGIN = `login`;

// jalnacollector@admin.com
// 123456789

export const DOMAIN = "https://telelawmh.in/apiv2collectorapp/public/";
export const BASEURL = DOMAIN + "api/";
export const USERLOGIN = `login`;
export const USERLOGOUT = `logout`;
export const GETVISIGTERRECORDS = `get-visiter-records`;
export const GETSTOREDVISIGTERRECORDS = `store-visiter-record`;







